class MegaMenu {
    constructor() {
      this.menus = document.querySelectorAll('header-menu');
      this.sliderMap = new Map(); // Track sliders for each menu
      console.log('MegaMenu: Found', this.menus.length, 'header menus');
      this.addStyles();
      this.addCloseButtons();
      this.init();
    }
  
    addStyles() {
      const styles = `
        /* Override existing grid layout for slider */
        .mega-menu__slider {
          display: block !important;
          grid-template-columns: none !important;
          grid: none !important;
          position: relative !important;
        }

        .mega-menu__slider .featured-collection__item {
          grid-column: unset !important;
          grid-row: unset !important;
        }

        /* Ensure proper spacing for Slick */
        .mega-menu__slider .slick-slide {
          padding: 0 0.5rem;
        }

        .mega-menu__slider .slick-list {
          margin: 0 -0.5rem;
        }

        /* Fix arrow visibility and positioning */
        .mega-menu__slider .slick-arrow {
          position: absolute !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          z-index: 10 !important;
          width: 40px !important;
          height: 40px !important;
          background: rgba(255, 255, 255, 0.9) !important;
          border: 1px solid rgba(0, 0, 0, 0.1) !important;
          border-radius: 50% !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          cursor: pointer !important;
          transition: all 0.3s ease !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
        }

        .mega-menu__slider .slick-arrow:hover {
          background: rgba(255, 255, 255, 1) !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        }

        .mega-menu__slider .slick-prev {
          left: -20px !important;
        }

        .mega-menu__slider .slick-next {
          right: -20px !important;
        }

        .mega-menu__slider .slick-arrow svg {
          width: 20px !important;
          height: 20px !important;
          fill: currentColor !important;
          color: #333 !important;
        }

        .mega-menu__slider .slick-arrow path {
          fill: currentColor !important;
          color: #333 !important;
        }

        /* Ensure slider container has proper positioning */
        .featured-collection {
          position: relative !important;
          overflow: visible !important;
        }

        /* Hide arrows on mobile if needed */
        @media (max-width: 768px) {
          .mega-menu__slider .slick-arrow {
            width: 35px !important;
            height: 35px !important;
          }
          
          .mega-menu__slider .slick-prev {
            left: -15px !important;
          }
          
          .mega-menu__slider .slick-next {
            right: -15px !important;
          }
        }
      `;
  
      const styleSheet = document.createElement('style');
      styleSheet.textContent = styles;
      document.head.appendChild(styleSheet);
    }
  
    addCloseButtons() {
      // For header-menu elements, close buttons are not needed
      // as they use hover/focus events handled by the header-menu.js
      console.log('MegaMenu: Skipping close buttons for header-menu elements');
    }
  
    init() {
      this.menus.forEach(menu => {
        this.setupSlider(menu);
        this.bindEvents(menu);
      });
      
      // Close menu when clicking outside
      document.addEventListener('click', (e) => {
        const target = e.target;
        if (target && target instanceof HTMLElement && !target.closest('.mega-menu') && !target.closest('.header__menu-item')) {
          this.closeAllMenus();
        }
      });
      
      // Handle escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllMenus();
        }
      });
    }
  
    setupSlider(menu) {
      const slider = menu.querySelector('.mega-menu__slider');
      if (!slider) {
        console.log('MegaMenu: No slider found in menu');
        return;
      }
  
      console.log('MegaMenu: Found slider', slider);
      const productsPerRow = parseInt(slider.dataset.productsPerRow) || 3;
      const items = slider.querySelectorAll('.featured-collection__item');
      
      console.log('MegaMenu: Found', items.length, 'items, productsPerRow:', productsPerRow);
      
      if (items.length === 0) return;
  
      // Wait for jQuery and Slick to be available
      const initSlider = () => {
        console.log('MegaMenu: Checking for jQuery and Slick...');
        console.log('MegaMenu: typeof $:', typeof $);
        console.log('MegaMenu: typeof $.fn.slick:', typeof $ !== 'undefined' ? typeof $.fn.slick : 'undefined');
        
        if (typeof $ === 'undefined' || typeof $.fn.slick === 'undefined') {
          console.log('MegaMenu: jQuery or Slick not ready, retrying...');
          setTimeout(initSlider, 100);
          return;
        }
  
        console.log('MegaMenu: Initializing Slick slider...');
        
        // Destroy existing slider if it exists
        if ($(slider).hasClass('slick-initialized')) {
          console.log('MegaMenu: Destroying existing slider');
          $(slider).slick('unslick');
        }
        
        const options = {
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: productsPerRow,
          slidesToScroll: 1,
          rows: 0,
          prevArrow: '<svg class="icon icon-caret-left slick-prev custom-slick-arrow" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>',
          nextArrow: '<svg class="icon icon-caret-right slick-next custom-slick-arrow" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: Math.min(productsPerRow - 1, 2)
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        };
  
        console.log('MegaMenu: Slick options:', options);
        
        // Temporarily show menu for proper initialization
        const wasHidden = menu.style.display === 'none';
        const originalDisplay = menu.style.display;
        menu.style.display = 'block';
        
        try {
          // Initialize slider
          $(slider).slick(options);
          console.log('MegaMenu: Slick slider initialized successfully');
        } catch (error) {
          console.error('MegaMenu: Error initializing Slick slider:', error);
        }
        
        // Restore original display
        if (wasHidden) {
          menu.style.display = originalDisplay;
        }
        
        // Store slider reference
        this.sliderMap.set(menu, slider);
      };
  
      // Initial initialization
      initSlider();
  
      // Handle resize events
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (menu.hasAttribute('open')) {
            const currentSlider = this.sliderMap.get(menu);
            if (currentSlider && typeof $ !== 'undefined') {
              $(currentSlider).slick('setPosition');           
            }
          }
        }, 250);
      });
  
      // Refresh slider when menu opens
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open') {
            const currentSlider = this.sliderMap.get(menu);
            if (currentSlider && menu.hasAttribute('open') && typeof $ !== 'undefined') {
              requestAnimationFrame(() => {
                $(currentSlider).slick('setPosition');
              });
            }
          }
        });
      });
  
      observer.observe(menu, { attributes: true });
    }
  
    bindEvents(menu) {
      // For header-menu elements, we don't need to bind click events
      // as they use hover/focus events handled by the header-menu.js
      console.log('MegaMenu: Binding events for menu', menu);
    }
  
    openMenu(menu) {
      // For header-menu elements, opening is handled by the header-menu.js
      console.log('MegaMenu: Opening menu', menu);
    }
  
    closeMenu(menu) {
      // For header-menu elements, closing is handled by the header-menu.js
      console.log('MegaMenu: Closing menu', menu);
    }
  
    closeAllMenus() {
      // For header-menu elements, this is handled by the header-menu.js
      console.log('MegaMenu: Closing all menus');
    }
  }
  
  // Initialize mega menu
  document.addEventListener('DOMContentLoaded', () => {
    console.log('MegaMenu: DOMContentLoaded, initializing...');
    window.megaMenuInstance = new MegaMenu();
  });

  // Also initialize on window load to ensure all dependencies are loaded
  window.addEventListener('load', () => {
    console.log('MegaMenu: Window load, checking for sliders...');
    // Re-initialize sliders if they weren't initialized before
    const existingMegaMenu = window.megaMenuInstance;
    if (existingMegaMenu) {
      existingMegaMenu.menus.forEach(menu => {
        const slider = menu.querySelector('.mega-menu__slider');
        if (slider && !slider.classList.contains('slick-initialized')) {
          existingMegaMenu.setupSlider(menu);
        }
      });
    }
  });
  